import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import type { FilterSortSettings } from 'webapp/models-custom/filter-sort/base';
import FilterSortClient from 'webapp/models-custom/filter-sort/client';
import type { FilterOption } from 'webapp/models-custom/filter-sort/filter';
import type Filter from 'webapp/models-custom/filter-sort/filter';
import type Space from 'webapp/models-custom/space';

export const timeframeFilterId = 4;

export default class FilterSortClientInOverview extends FilterSortClient {
	@service('timeframe') declare timeframeService: Service.Timeframe;

	@tracked override sortProp = 'order';

	override itemDomSelector = '.table-row:not(.empty)';

	constructor(options: FilterSortSettings<Space>, isGoalPage: boolean) {
		super(options);

		if (isGoalPage) {
			const selectedFilters = this.readSavedSelectedFilters();

			// Goals timeframe selector
			// technically, its for goals instead of clients, but is part of the same filter
			// will be accessed in the view itself, so filterFn always returns true
			const timeframeFilter: Filter<Space, string> = this.createFilter<string>({
				id: timeframeFilterId,
				label: 'Timeframe',
				name: 'timeframe',
				selected: selectedFilters[timeframeFilterId] as string | undefined,
				isMultiSelect: false,
				stringValues: true,
				getOptions: () => {
					return this.timeframeOptions;
				},
				filterFn: (_item, _selected) => {
					return true;
				},
				createPopupFn: (attachTo: HTMLElement, _extraClass: string, theme?: string) => {
					return this.timeframeService.openTimeframePopupForFilter(
						timeframeFilter as Filter<unknown, string>,
						attachTo,
						theme,
					);
				},
			});
		}
	}

	get timeframeOptions(): FilterOption<string>[] {
		const timeframeFilter = this.filters.find(
			(filter) => filter.id === timeframeFilterId,
		) as Filter<Space, string>;
		return this.timeframeService.getTimeframeOptionsForFilter(
			timeframeFilter as Filter<unknown, string>,
		);
	}
}
